import React, { useEffect } from 'react'
import ReactAudioPlayer from 'react-audio-player';
import Slider from 'react-slick';
// import "./style.scss";
import Image from 'next/image';
import BayanNews from '../../../../common/bayanNews';

function News(props) {
	const data = props?.newsEventPageData && props?.newsEventPageData.length ? props?.newsEventPageData[0] : null;
	// console.log(data);
	useEffect(() => {
		const facebookScript = document.createElement("script");
		facebookScript.async = true;
		facebookScript.src = `https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.2`;
		document.body.appendChild(facebookScript);
	}, []);
	return (
		<>
			<div className="bayan-media bayan-media-blue mobile-event">
			<BayanNews page_title={data?.page_title ?? ''} news_events={data?.news_event_media ?? ''}/>
				<div className="container">
					<div id="social-media">
						<h2 className="text-center headingF">{data?.social_media_contant?.heading ?? ''}</h2>
						<div className="row">
							<div className="col-3">
							
							</div>
							<div className="col-3">
								<div className="fb-post"
									 data-href={data?.social_media_contant?.fb_post_link ?? ''}
									 data-width="370" data-height="400" data-show-text="true">
								</div>
							</div>
							<div className="col-3">
							</div>
						</div>
					</div>
				</div>
			</div>

		</>
	);
}

export default News;
